import axios from 'axios'
import { ref } from 'vue'
import { showConsoleError } from '@/functions/errors'
import { APIS_DRIVE, APIS_KPI } from '@/constants/apis'
import { TOKEN } from '@/constants/labels'
import { PARAMETROS } from '@/interfaces/SmartLink/Equipos'


export async function postKillProccessAll() {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_DRIVE.value.killProccessAll, { headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: any = response.data.body;
      const finalObj = ref<any[]>([])
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {
        finalObj.value = finalData
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}

export async function postKillProcessDrive() {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_DRIVE.value.killProcessDrive, { headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: any = response.data.body;
      const finalObj = ref<any[]>([])
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {
        finalObj.value = finalData
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}

export async function postHeatMapRAJANT(params: any) {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_DRIVE.value.postHeatMapRAJANT, { params: params, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: any = response.data.body;
      const finalObj = ref<any>()
      const showGraphs = ref(finalData.length > 0)
      // if (finalData) {
      //   finalObj.value = finalData
      // }
      finalObj.value = finalData
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}

export async function postHeatMap(params: any) {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_DRIVE.value.postHeatMap, { params: params, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: any = response.data.body;
      const finalObj = ref<any[]>([])
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {
        finalObj.value = finalData
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}

export async function getAllClientDevice() {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_DRIVE.value.getAllClientDevice, { headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: any = response.data;
      const finalObj = ref<any[]>([])
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {
        finalData.forEach((item: any) => {
          const objClient = {
            title: `${item.name} - ${item.ip}`,
            value: item.ip
          }
          finalObj.value.push(objClient);
        })
        // finalObj.value = finalData
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}


export async function getAllDriveClientsDevices() {
  // Declaramos explícitamente el tipo de statusAxios
  let statusAxios: { status: number; data: any[]; showGraphs: boolean } = {
    status: 400,
    data: [],
    showGraphs: false,
  };

  try {
    const response = await axios.get(APIS_KPI.value.getAllCostLastMinute, {
      headers: { Authorization: `Bearer ${TOKEN}` },
    });

    const finalData: any[] = response.data || [];
    const showGraphs = finalData.length > 0;

    const filteredData = finalData.filter((item: any) => {
      if (!item.wireless || typeof item.wireless !== "object") return false;

      // Verifica si alguna interfaz (wlan0, wlan1, etc.) contiene el arreglo 'clients'
      return Object.values(item.wireless).some(
        (wlan: any) => wlan && Array.isArray(wlan.clients) && wlan.clients.length > 0
      );
    });

    statusAxios = {
      status: 200,
      data: filteredData,
      showGraphs,
    };
  } catch (error) {
    statusAxios = { status: 400, data: [], showGraphs: false };
    showConsoleError(error);
  }

  return statusAxios;
}


export async function getRajantIPS() {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_DRIVE.value.getRajantIPS, { headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: any = response.data;
      const finalObj = ref<any[]>([])
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {
        finalData.forEach((item: any) => {
          const anotation = item.anotacion ?? {}
          if (anotation.server_bcapi) finalObj.value.push(anotation.server_bcapi)
        })
        // finalObj.value = finalData
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}

export async function getRajantGPS() {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_DRIVE.value.getRajantGPS, { headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: any = response.data;
      const finalObj = ref<any[]>([])
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {
        finalObj.value = finalData
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}

export async function getRajantPerfomance() {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_DRIVE.value.getRajantPerfomance, { headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: any = response.data;
      const finalObj = ref<any[]>([])
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {
        finalObj.value = finalData
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}

export async function postBandWidth(params: any) {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_DRIVE.value.postBandWidth, { params: params, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: any = response.data.body;
      const finalObj = ref<any>()
      const showGraphs = ref(finalData.length > 0)
      if (finalData) {
        finalObj.value = finalData
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}

export async function validateRunScripts() {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_DRIVE.value.validateRunScripts, { headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: any = response.data.body;
      const finalObj = ref<any[]>([])
      const showGraphs = ref(finalData.length > 0)
      if (finalData) {
        finalObj.value = finalData
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}


export async function getAllLatencyDriveByIP(params: PARAMETROS) {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_DRIVE.value.getLatencyDriveByIP, { params: params, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: any = response.data;
      const finalObj = ref<any[]>([])
      const showGraphs = ref(finalData.length > 0)
      if (finalData) {
        finalObj.value = finalData
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}

export async function getAllLocationDriveByIP(params: PARAMETROS) {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_DRIVE.value.getLocationDriveByIP, { params: params, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: any = response.data;
      const finalObj = ref<any[]>([])
      const showGraphs = ref(finalData.length > 0)
      if (finalData) {
        finalObj.value = finalData
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}